/**
 * Product Image Manager
 * Preloads images and ensures smooth variant switching
 */

class ProductImageManager {
  constructor() {
    this.init();
  }

  init() {
    document.addEventListener('DOMContentLoaded', () => {
      this.preloadProductImages();
    });
    
    // Listen for variant changes
    document.addEventListener('theme:variant:change', (event) => {
      this.handleVariantChange(event);
    });
  }

  preloadProductImages() {
    // Find all product images on the page
    const productImages = document.querySelectorAll('product-images [data-image-id] img');
    
    productImages.forEach(img => {
      // Force eager loading for all product images
      img.loading = 'eager';
      
      // Preload the image
      const preloader = new Image();
      preloader.src = img.src;
      
      // Also preload srcset images if they exist
      if (img.srcset) {
        const srcsetUrls = img.srcset.split(',').map(src => src.trim().split(' ')[0]);
        srcsetUrls.forEach(url => {
          const srcsetPreloader = new Image();
          srcsetPreloader.src = url;
        });
      }
    });
  }

  handleVariantChange(event) {
    const variant = event.detail.variant;
    if (!variant || !variant.featured_media) return;

    const productImages = event.target.querySelector('product-images');
    if (!productImages) return;

    const newImageContainer = productImages.querySelector(`[data-media-id="${variant.featured_media.id}"]`);
    if (!newImageContainer) return;

    const newImage = newImageContainer.querySelector('img');
    if (!newImage) return;

    // Check if image is ready before switching
    this.ensureImageReady(newImage, () => {
      productImages.setActiveMedia(variant.featured_media.id);
    });
  }

  ensureImageReady(img, callback) {
    if (img.complete && img.naturalHeight !== 0) {
      // Image is already loaded
      callback();
    } else {
      // Wait for image to load
      const imageLoader = new Image();
      imageLoader.onload = callback;
      imageLoader.onerror = callback; // Still switch even if error
      imageLoader.src = img.src;
    }
  }
}

// Initialize when DOM is ready
new ProductImageManager();